import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Table,
} from "reactstrap";
import { getStorageCompany } from "../../helpers/api_helper";
import { deletePapeletaAccessa, getLogsAccessa, postChangeTextAccessa, postInitPapeletaAccessa, postInitProximasParadasAccessa, postInitProximasSalidasAccessa, postResetOdometerTemAccessa, postResetOdometerTotalAccessa, postResetOverSpeedsAccessa, postResetPenaltiesAccessa, postSendAccessa, postSendProximasParadasAccessa, postSendProximasSalidasAccessa, postSetOdometerTotalAccessa } from "../../helpers/backend_helper";
import dayjs from "dayjs";

const BASE_URL_BACK = process.env.REACT_APP_BACKEND_API_LOGIN_URL;

const AccessaModal = ({ modal, setModal }) => {
  const company = getStorageCompany();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(false);

  const [texto, setTexto] = useState("")
  const [odometro, setOdometro] = useState(0)

  const eliminarSalida = () => {
    setLoading(true);
    deletePapeletaAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const enviarSalida = () => {
    setLoading(true);
    postSendAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const initSalida = () => {
    setLoading(true);
    postInitPapeletaAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const enviarProximasParadas = () => {
    setLoading(true);
    postSendProximasParadasAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const initProximasParadas = () => {
    setLoading(true);
    postInitProximasParadasAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const ResetPenalties = (unitId) => {
    setLoading(true);
    postResetPenaltiesAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const ResetOverSpeeds = (unitId) => {
    setLoading(true);
    postResetOverSpeedsAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const ResetOdometerTotal = (unitId) => {
    setLoading(true);
    postResetOdometerTotalAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const ResetOdometerTemp = (unitId) => {
    setLoading(true);
    postResetOdometerTemAccessa(modal.row.id, {})
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const SetOdometerTotal = (unitId) => {
    setLoading(true);
    postSetOdometerTotalAccessa(modal.row.id, { odometro })
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const ChangeText = (unitId) => {
    setLoading(true);
    postChangeTextAccessa(modal.row.id, { texto })
      .then((response) => {
        console.log(response);
        reloadLogs();
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  const reloadLogs = async () => {
    setLoadingLogs(true);
    try {
      const response = await getLogsAccessa(modal.row.id)
      console.log(response);
      if (response.status) {
        setLogs(response.logs || []);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingLogs(false);
  }

  useEffect(() => {
    if (modal.show) {
      reloadLogs();
    }
  }, [modal.show]);

  return (
    <div>
      <Modal isOpen={modal.show} size="lg">
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            //validation.handleSubmit();
            return false;
          }}
        >
          <ModalHeader className="bg-primary">Control Accessa</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-6 mb-3">
                <div>Salida</div>
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={enviarSalida}
                >
                  <i className="fa fas fa-cloud-upload-alt"></i> Enviar Salida
                </Button>{" "}
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={initSalida}
                >
                  <i className="fa fas fa-play"></i> Inicializar Salida
                </Button>{" "}
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={eliminarSalida}
                >
                  <i className="fa fas fa-times"></i> Eliminar Salida
                </Button>{" "}
              </div>
              <div className="col-6 mb-3">
                <div>Paradas</div>
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={enviarProximasParadas}
                >
                  <i className="fa fas fa-cloud-upload-alt"></i> Enviar próximas paradas
                </Button>{" "}
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={initProximasParadas}
                >
                  <i className="fa fas fa-play"></i> Inicializar próximas paradas
                </Button>{" "}
              </div>
              <div className="col-6 mb-3">
                <div>Otros comandos</div>
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={ResetPenalties}
                >
                  <i className="fa fa-redo"></i> Reset de Penalizaciones
                </Button>{" "}
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={ResetOverSpeeds}
                >
                  <i className="fa fa-redo"></i> Reset excesos de velocidad
                </Button>{" "}
              </div>

              <div className="col-6 mb-3">
                <div>Odómetro</div>
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={ResetOdometerTotal}
                >
                  <i className="fa fa-tachometer-alt"></i> Reiniciar odometro total
                </Button>{" "}
                <Button color="primary" type="submit" size={'sm'} disabled={loading}
                  onClick={ResetOdometerTemp}
                >
                  <i className="fa fa-tachometer-alt"></i> Reiniciar odometro temporal
                </Button>{" "}
              </div>

              <div className="col-6 mb-3">
                <div className="row">
                  <div className="col-6 mb-3">
                    <Button color="primary" type="submit" size={'sm'} disabled={loading}
                      onClick={ChangeText}
                    >
                      <i className="fab fa-chromecast"></i> Cambiar texto en pantalla
                    </Button>{" "}
                  </div>
                  <div className="col-6 mb-3">
                    <input
                      type="nummber"
                      onChange={(e) => setTexto(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-6 mb-3">
                <div className="row">
                  <div className="col-6 mb-3">
                    <Button color="primary" type="submit" size={'sm'} disabled={loading}
                      onClick={SetOdometerTotal}
                    >
                      <i className="fa fa-tachometer-alt"></i> Inicializar Odometro total
                    </Button>{" "}
                  </div>
                  <div className="col-6 mb-3">
                    <input
                      type="number"
                      onChange={(e) => setOdometro(e.target.value)}
                    />
                  </div>
                </div>
              </div>


              <div className="col-12">
                <div className="text-center">
                  {loading && <Spinner color={'primary'} size="md"></Spinner>}{" "}
                </div>

                <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                  <Table size="sm" bordered>
                    <thead>
                      <tr className="bg-light">
                        <th>
                          Fecha/Hora
                        </th>
                        <th>
                          Evento / Data
                          <Button color="secondary" type="submit" size={'sm'} disabled={loadingLogs} className={"float-end"}
                            onClick={reloadLogs}
                          >
                            {loadingLogs && <Spinner size="sm"></Spinner>}{" "}
                            <i className="fa fas fa-sync"></i> Cargar Logs
                          </Button>{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map((log, index) => (
                        <tr key={index}>
                          <td>
                            <small>{dayjs(log.created_at).format('DD/MM/YYYY HH:mm:ss')}</small><br />
                          </td>
                          <td style={{ wordBreak: 'break-all' }}>
                            <b><small>{log.event}</small></b><br /><small>{JSON.stringify(log.data)}</small></td>
                        </tr>
                      ))}
                      {logs.length === 0 && (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No hay logs disponibles
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={() => setModal({ ...modal, show: false })}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AccessaModal;
